// JS
import '../../custom/js/custom/index';

// Vendor CSS
import 'simplebar/dist/simplebar.css';

// Base SCSS
import '../../custom/scss/common/base.scss';
import '../../custom/scss/custom/layout.scss';

// Components SCSS
import '../../custom/scss/common/components/card/card.scss';
import '../../custom/scss/common/components/card/card-list.scss';
import '../../custom/scss/common/components/card/card-grid.scss';
import '../../custom/scss/common/components/filter/filter-header.scss';
import '../../custom/scss/common/components/filter/filter-sidebar.scss';
import '../../custom/scss/common/components/pagination/pagination.scss';
import '../../custom/scss/custom/components/search/search-list.scss';
import '../../custom/scss/custom/components/hero/hero.scss';
import '../../custom/scss/custom/components/breadcrumb/breadcrumb.scss';


// import Vue App
import Vue from 'vue';
import VueApp from '../../custom/vue/list-filter';
import App from '../../custom/vue/custom-apps/containers/search-list-filter-app.vue';

// connect vue component and init app
Vue.component('app', App);
VueApp.$mount('#search-list-filter-app');